import { Component, OnInit, OnDestroy, HostBinding, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { MathtagService } from 'app/shared/analytics/mathtag/mathtag.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { CursosService } from 'app/graduacao/cursos/shared/cursos.service';
import { FluxoVestibularService } from '../shared/fluxoVestibular.service';
import { environment } from '../../../../environments/environment';

import { DadosVestibular } from 'models/dados-vestibular';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './curso.component.html',
  styleUrls: ['./curso.component.scss'],
  animations: [routerTransition],
  providers: [CursosService],
})
export class CursoComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  environment = environment;
  dadosVestibular: DadosVestibular = new DadosVestibular({});
  loading = true;
  cursoIdParam = '';
  curso: any = '';
  polo: any = '';
  cidade: any = '';
  auxCampusTurno: any = {};
  campusTurno: any = null;

  dadosVestibularSubscription: Subscription;
  queryParamsSubscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoVestibularService: FluxoVestibularService,
    private analytics: AnalyticsService,
    private mathtag: MathtagService,
  ) { }

  ngOnInit() {
    this.queryParamsSubscription = this.route.queryParams.subscribe(queryParams => {
      this.cursoIdParam = queryParams['curso'];
    });

    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    if (!this.dadosVestibular.vestibular) {
      this.dadosVestibularSubscription = this.fluxoVestibularService.dadosVestibularMessage$.subscribe(() => {
        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.dadosVestibularSubscription.unsubscribe();
      });
    } else {
      this.analytics.registrar(
        `Vestibular`,
        `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
        'Informações do curso',
      );
    }
  }



  compararObjetosPorId(obj1, obj2) {
    return obj1 && obj2 && obj1.id === obj2.id;
  }

  calcValorFinal(curso, campusTurno): number {
    let preco = curso.valorBase;
    if (campusTurno.desconto) {
      preco *= (1 - (campusTurno.desconto / 100));
    }
    return preco;
  }

  ngOnDestroy() {
    // remove script Remarketing
    if (environment.production === 'true' && this.dadosVestibular.vestibular.sigla === 'EA') {
      this.mathtag.removerTodosScripts();
    }

    if (this.dadosVestibularSubscription) {
      this.dadosVestibularSubscription.unsubscribe();
    }
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  handleEventChange({ campusTurnoInfo, campusTurno }: any) {
    this.campusTurno = campusTurnoInfo;
    this.auxCampusTurno = campusTurno;
  }

  nextStep(selecaoCurso) {
    //console.log(selecaoCurso);
    // add reemarketing track
    if (environment.production === 'true' && this.dadosVestibular.vestibular.sigla === 'EA') {
      this.mathtag.inscricaoCurso();
    }

    this.fluxoVestibularService.proximoPasso({
      cursoSelecionado: {
        curso: selecaoCurso.curso,
        cidade: selecaoCurso.cidade,
        polo: selecaoCurso.polo,
        auxCampusTurno: selecaoCurso.auxCampusTurno,
        campusTurno: selecaoCurso.campusTurno,
        investimento: this.calcValorFinal(selecaoCurso.curso, selecaoCurso.campusTurno),
      },
    });

    this.analytics.registrar('Vestibular', 'Cursos', selecaoCurso.curso.nome);
    this.analytics.registrar('Vestibular', 'Polos', selecaoCurso.polo.nome);
    this.analytics.registrar('Vestibular', 'Turnos', selecaoCurso.campusTurno.turno);
    this.analytics.registrar(
      'Vestibular',
      'Cidades dos cursos',
      `${selecaoCurso.cidade.id}: ${selecaoCurso.cidade.nome}`,
    );

    const proximaRota = this.fluxoVestibularService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }

  isBtnNextDisabled(): boolean {
    return !this.campusTurno || !this.auxCampusTurno ||
      !this.campusTurno.id || !this.auxCampusTurno.campus;
  }

}
